import { HEADINGS_DROPDOWN_TYPE as type } from './types';
export const DEFAULTS = Object.freeze({
  type,
  config: {},
});
